export const Loader = () => {
  return (
    <div className='container_dot'>
      <div className='dot' />
    </div>
  );
};
